import { render, staticRenderFns } from "./overlay-loader.vue?vue&type=template&id=382e78c8&scoped=true&"
import script from "./overlay-loader.vue?vue&type=script&lang=js&"
export * from "./overlay-loader.vue?vue&type=script&lang=js&"
import style0 from "./overlay-loader.vue?vue&type=style&index=0&id=382e78c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382e78c8",
  null
  
)

export default component.exports